import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonuses, bonusValueRows } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-sage-light border-y border-sage" data-id="element-16" data-mp="22ebqysm0mq8w">
      <div className="max-w-5xl mx-auto" data-id="element-17" data-mp="1ydrwxxwqo2qz">
        <div className="text-center mb-16" data-id="element-18" data-mp="1yet7805xkl7n">
          <p className="text-gold-dark font-bold tracking-widest uppercase mb-2" data-id="element-19" data-mp="1anxl9jo5ok8b">
            Included as part of the complete system — not sold separately anywhere
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-ink" data-id="element-20" data-mp="1jgr39ouzlxpv">
            🎁 The 5 Strategic Bonuses
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-21" data-mp="1eozkw1lziyat">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border border-gold/30 rounded-2xl p-8 relative shadow-sm" data-id="element-22" data-mp="qz5adqp51ltq" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-forest text-cream-light px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-23" data-mp="2jhwbc7t83qbq">
                🎁 BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-gold/15 rounded-full flex items-center justify-center text-gold-dark mb-4" data-id="element-24" data-mp="1qt8mk299mitf">
                <Gift size={24} data-id="element-25" data-mp="1vrs8w3rrtwmb" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-24 text-ink" data-id="element-26" data-mp="1vsk5nhx3u0e6">
                {bonus.title}
              </h3>
              <p className="text-sm text-forest font-medium mb-4 leading-snug" data-id="element-27" data-mp="25qhua6ivlz7b">
                {bonus.headline}
              </p>
              <div className="inline-block bg-cream px-3 py-1 rounded mb-4 border border-sage" data-id="element-28" data-mp="3c7d4x8skxd9j">
                <span className="text-charcoal text-sm" data-id="element-29" data-mp="3h4vcovuv1mfy">
                  Real value: <span className="line-through" data-id="element-30" data-mp="1h3ezphh30v1y">${bonus.value}</span>
                </span>
                <span className="text-gold-dark font-bold ml-2" data-id="element-31" data-mp="1c4asuxhmr9es">→ FREE</span>
              </div>
              <ul className="space-y-3 mb-6" data-id="element-32" data-mp="1c6oj8t1d7xg0">
                {bonus.points.map(point => <li key={point} className="text-charcoal text-sm leading-relaxed" data-id="element-33" data-mp="1q1qyw7w0l160">
                    {point}
                  </li>)}
              </ul>
              <p className="text-forest text-sm italic font-medium" data-id="element-34" data-mp="ydfdd2cmlu28">{bonus.benefit}</p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-gold/40 rounded-2xl p-8 max-w-2xl mx-auto shadow-sm" data-id="element-35" data-mp="1757ozgddz98e">
          <h3 className="text-2xl font-serif font-bold text-ink text-center mb-6" data-id="element-36" data-mp="en3pbrn910q3">
            💰 Total Value of the 5 Bonuses
          </h3>
          <div className="overflow-hidden rounded-xl border border-sage" data-id="element-37" data-mp="jo79lffa0yj">
            <table className="w-full text-left" data-id="element-38" data-mp="hjusf3gjtmn">
              <thead className="bg-forest text-cream-light text-xs uppercase tracking-wider" data-id="element-39" data-mp="5b69sdx3g9lm">
                <tr data-id="element-40" data-mp="3mre3t5y5dvvm">
                  <th scope="col" className="px-4 py-3 font-bold" data-id="element-41" data-mp="3ms5ymejx7pku">
                    Bonus
                  </th>
                  <th scope="col" className="px-4 py-3 font-bold text-right" data-id="element-42" data-mp="3rpz2v21ny9ih">
                    Value
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-43" data-mp="o7xqcfl94alz">
                {bonusValueRows.map(row => <tr key={row.label} className="border-t border-sage" data-id="element-44" data-mp="9bygp0ihu2eq">
                    <td className="px-4 py-3 text-sm text-charcoal" data-id="element-45" data-mp="9e2klige71f0">{row.label}</td>
                    <td className="px-4 py-3 text-sm text-ink font-medium text-right" data-id="element-46" data-mp="e8yhavwkqcyg">
                      {row.value}
                    </td>
                  </tr>)}
                <tr className="border-t border-sage bg-cream" data-id="element-47" data-mp="2z2lcjmsh0c7c">
                  <td className="px-4 py-3 text-sm font-bold text-ink" data-id="element-48" data-mp="3f8etaxpdouuq">Total Bonus Value</td>
                  <td className="px-4 py-3 text-sm font-bold text-ink text-right line-through" data-id="element-49" data-mp="3agwqe43sok74">
                    $111
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="text-center mt-6" data-id="element-50" data-mp="30kbklgjyb528">
            <p className="text-lg text-ink mb-2" data-id="element-51" data-mp="30hfnfufxgkeu">Your Price Today</p>
            <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-52" data-mp="214ojpe1aimo">🎁 FREE</p>
            <p className="text-sm text-charcoal" data-id="element-53" data-mp="3t8zchuz7gsor">Only included with this offer.</p>
          </div>
        </motion.div>

        <CountdownTimer data-id="element-54" data-mp="3o79yc6gorywg" />
      </div>
    </section>;
}